var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalOperator',{staticClass:"no-border",attrs:{"width":330,"type":"primary","iconType":"md-settings","iconSize":"18","text":"微信绑定","title":"微信绑定","customButton":true}},[_c('div',{attrs:{"id":"login_container"}},[_vm._v("正在生成二维码，请稍后")])])
}
var staticRenderFns = []

export { render, staticRenderFns }